import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const steps = [
  "Mapping",
  "Extraction",
  "Validation",
  "Review",
  "Approval",
  "Submitted",
];

const BoldLine = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "20px",
  backgroundColor: "#4096FC",
  display: "flex",
  justifyContent: "space-between",
  position: "relative",
}));

const BoldLinePart = styled(Box)(({ theme, selected }) => ({
  width: "25%",
  height: "100%",
  backgroundColor: selected ? "#4096FC" : "#eaeaf0",
  position: "relative",
  display: "flex",
  justifyContent: "center",
}));

const LineAndCircleContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: "-70px",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
}));

const Line = styled(Box)(({ theme, selected }) => ({
  width: "2px",
  height: "15px",
  backgroundColor: selected ? "#4096FC" : "#eaeaf0",
}));

const Circle = styled(Box)(({ theme, selected }) => ({
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  backgroundColor: selected ? "#4096FC" : "#eaeaf0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: selected ? "#fff" : "#000",
}));

const StepLabel = styled(Box)(({ theme, selected }) => ({
  marginTop: "5px",
  color: selected && "#4096FC",
  fontWeight: selected ? "bold" : "normal",
}));

const CustomizedSteppers = ({ currentStep = "", statusLoading }) => {
  const currentStepIndex = steps.indexOf(currentStep);

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      <BoldLine>
        {statusLoading && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
            }}
          >
            <CircularProgress />
          </Box>
        )}
        {steps.map((label, index) => {
          const isSelected = index <= currentStepIndex;
          return (
            <BoldLinePart key={index} selected={isSelected}>
              <LineAndCircleContainer>
                <Line selected={isSelected} />
                <Circle selected={isSelected}>{index + 1}</Circle>
                <StepLabel selected={isSelected}>{label}</StepLabel>
              </LineAndCircleContainer>
            </BoldLinePart>
          );
        })}
      </BoldLine>
    </Box>
  );
};

CustomizedSteppers.propTypes = {
  currentStep: PropTypes.string,
  statusLoading: PropTypes.bool,
};

export default CustomizedSteppers;
